<h4 matDialogTitle data-cy="add-payment-title">View\Add a Payment</h4>

<mat-dialog-content>
  <table class="table table-striped" data-cy="payments-table">
    <thead *ngIf="payments.length > 0">
      <tr>
        <th>Amount</th>
        <th>Method</th>
        <th>Received By</th>
        <th>Date Received</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let payment of payments">
        <td>
          {{
            payment.amount * currencyRate
              | currency : currency : 'symbol' : '1.2-2'
          }}
        </td>
        <td>{{ payment.method }}</td>
        <td>{{ payment.user_id | userIdToName | async }}</td>
        <td>{{ payment.created_at | amDateFormat : dateTimeFormat }}</td>
        <td>
          <button
            data-cy="delete-payment"
            mat-icon-button
            (click)="delete(payment)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <p data-cy="no-payments-message" *ngIf="payments.length === 0">
    No payments yet
  </p>
  <p data-cy="total-paid" *ngIf="payments.length > 0">
    <strong>Total Paid:</strong>
    {{ paid | currency : currency : 'symbol' : '1.2-2' }}
  </p>
  <p data-cy="balance">
    <strong>Balance:</strong>
    {{ balance | currency : currency : 'symbol' : '1.2-2' }}
  </p>

  <p *ngIf="currency !== defaultCurrency">
    <strong>The currency for this transaction is set to {{ currency }}</strong>
  </p>
  <form #newPaymentForm="ngForm" (ngSubmit)="save()" fxLayout="column">
    <mat-form-field>
      <mat-select
        autofocus
        placeholder="Payment Method"
        name="Payment Method"
        id="method"
        data-cy="payment-method"
        [(ngModel)]="newPayment.method"
        required="true"
      >
        <mat-option *ngFor="let method of methods" [value]="method.name"
          >{{ method.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <input
        type="number"
        min="0"
        placeholder="Amount"
        matInput
        required
        name="Amount"
        data-cy="payment-amount"
        [(ngModel)]="newPayment.amount"
      />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="dialogRef.close()" data-cy="close-payment">
    Close
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    data-cy="save-payment"
    [disabled]="!newPaymentForm.form.valid || !newPaymentForm.form.dirty"
  >
    Save
  </button>
</mat-dialog-actions>
